import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, retry, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';

const apiURLs = {
  root: environment.apiURL,
  dashboardData: '/products/dashboard',
  dashboardProductChartData: (productId: string) => `/products/dashboard/chart/${productId}`,
  dashboardPensionOnTrackData: '/products/dashboard/pension/onTrack'
};

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private showCalculator = new BehaviorSubject<boolean>(false);
  private showTiles = new Subject<void>();
  public calculatorData = new BehaviorSubject<{name: string, value: number}>({name: '', value: 0});
  public goalSeekData = new BehaviorSubject<{projected: number, goal: number}>({projected: 0, goal: 0});

  constructor(
    private http: HttpClient,
  ) { }

  toggleCalculator(showCalculator: boolean) {
    this.showCalculator.next(showCalculator);
  }

  shouldShowCalculator() {
    return this.showCalculator.asObservable();
  }

  requestShowTiles() {
    this.showTiles.next();
  }

  shouldShowTiles() {
    return this.showTiles.asObservable();
  }

  getDashboardData(): Observable<any> {
    return this.http.get(apiURLs.root + apiURLs.dashboardData).pipe(
      retry({
        count: 3,
        delay: 1000
      })
    );
  }

  getProductChartData(productId: string): Observable<any> {
    return this.http.get(apiURLs.root + apiURLs.dashboardProductChartData(productId));
  }

  calculatePensionOnTrackData(params: any): Observable<any> {
    return this.http.get(apiURLs.root + apiURLs.dashboardPensionOnTrackData, {params: params});
  }

  calculateGoal(salary: number, yearsToRetirement: number): number {
    const inflationRate = 0.02; // 2% fixed inflation rate

    // Calculate future value using the formula: Salary * (1 + inflation rate) ^ years to retirement age
    const futureValue = salary * Math.pow((1 + inflationRate), yearsToRetirement);

    return futureValue;
  }

  calculateGoalYear(retirementAge: number, age: number) {
    const currentYear = moment().year();
    return currentYear + (retirementAge - age);
  }

  calculateGoalSeek(name: string, value: number) {
    this.calculatorData.next({name: name, value: value});
  }

  calculateGoalSeekFound(projected: number, goal: number) {
    this.goalSeekData.next({projected: projected, goal: goal});
  }

  calculateGoalSavings(salary: number) {
    return salary * 3;
  }
}
